import axios from 'axios';

const uploadInstance = axios.create();

export default uploadInstance;
